import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { sendToSalesFlow, setDigitalData } from '../../Utilities/Utils.js';

import './Join.css';

class DGRJoin extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.setValue( 'membership_flow' , true);
        setDigitalData( 'join', this.props.DGRStore.club_number );
    }

    costcoClicked = (e) => {
        this.props.DGRStore.setProductID( 'costco' );
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Join',
            action: 'Pre-Paid Memberships'
        });
        if ( this.props.DGRStore.values.lead_number ) {
            e.preventDefault();
            const { club_number } = this.props.DGRStore;
            sendToSalesFlow( 'costco', club_number, this.props.DGRStore.values );
        }
    }

    featuredProductClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Join',
            action: 'Featured Product Select'
        });

        e.preventDefault();
        this.props.DGRStore.setProductID( e.currentTarget.name );
        //TODO - possibly bailout function if missing product_id and club_number 
        const { club_product_id, club_number } = this.props.DGRStore 
        const { lead_number, is_waiver_signed } = this.props.DGRStore.values;

        // No lead number means we don't have them signed in with a lead.
        if ( !lead_number ) {
            this.props.history.push('enter_pass');
        // Lead exists, but the waiver isn't signed yet.
        } else if ( !is_waiver_signed ) {
            this.props.history.push('sign_waiver');
        // Lead exists and waiver is signed. Check for product id.
        } else if ( club_product_id && club_number ) {
            sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
        // No product selected, so go home and reset.
        } else {
            this.props.DGRStore.clearValues();
            this.props.history.replace('');
        }
    }

    membershipOptionsClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Join',
            action: 'Membership Options'
        });
    }

    corporateClicked = (e) => {
        this.props.DGRStore.setProductID( 'corporate' );
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Join',
            action: 'Corporate'
        });
        if ( this.props.DGRStore.values.lead_number ) {
            e.preventDefault();
            const { club_number } = this.props.DGRStore;
            sendToSalesFlow( 'corporate', club_number, this.props.DGRStore.values );
        }
    }

    renderCommitment() {
        var featuredProduct = this.props.DGRProductStore.featuredProduct;
        if ( featuredProduct.is_commit ) {
            return (
                <div className="optionSubline">
                    { featuredProduct.commitment_months } month commitment required
                </div>
            );
        } else {
            return '';
        }
    }

    render(){
        var featuredProduct = this.props.DGRProductStore.featuredProduct 
        return (
            <div className="">  
			    <Fade>
                <div className="join">  
                    <div className="joinTitleText">
                        <div className="joinTitleTextSub">
                             <h2>How would you like to join today?</h2>
                        </div>
                    </div>
                    <div className="optionsBox">
                        <Link to="/enter_pass" tabIndex="-1" onClick={ this.costcoClicked }>
                            <button className="sideButton">
                                <div>Activate</div>
                                <div>Pre-Paid</div>
                                <div>Memberships</div>
                            </button>
                        </Link>
                        <div className="centerButtons">
                            <Link className="topOptionsButton" to="/membership_options" name={ featuredProduct.id } onClick={ this.featuredProductClicked }> 
                                <div className="optionPrice">
                                    {featuredProduct.monthly_dues}<span className="priceTag">/mo</span>
                                </div>
                                <div className="optionTitle">
                                    { featuredProduct.name }
                                </div>
                                { this.renderCommitment() }
                            </Link>
                            <div className="buttonSep"></div>
                            <Link className="bottomOptionsButton" to="/membership_options" onClick={ this.membershipOptionsClicked }> 
                                <div className="optionSeeAll">
                                    See All Membership 
                                <br/>
                                    Options
                                </div>
                            </Link>
                        </div>
                        <Link to="/enter_pass" tabIndex="-1" onClick={ this.corporateClicked }>
                            <button className="sideButton" >
                                <div>Activate</div>
                                <div>Corporate</div>
                                <div>Membership</div>
                            </button>
                        </Link>
                    </div>
                </div>
                </Fade>
            </div>
        )
    }
}

DGRJoin = inject('DGRStore', 'DGRBackgroundStore','DGRProductStore')(observer(DGRJoin ))    
export default DGRJoin;



// WEBPACK FOOTER //
// ./src/components/DGR/Join/Join.js